import React from 'react';
import { DevelopersHero } from '../components/sections/DevelopersHero';
import { QuickstartSection } from '../components/sections/QuickstartSection';
import { CoreConcepts } from '../components/sections/CoreConcepts';
import { ProductAPIs } from '../components/sections/ProductAPIs';
import { IntegrationFlow } from '../components/sections/IntegrationFlow';
import { SDKsTooling } from '../components/sections/SDKsTooling';
import { DeveloperSupport } from '../components/sections/DeveloperSupport';
import { ModeProps } from '../types';
export function DevelopersPage({
  mode
}: ModeProps) {
  if (mode !== 'business') return null;
  return <main className="flex-grow" data-id="element-763">
      <DevelopersHero data-id="element-764" />
      <QuickstartSection data-id="element-765" />
      <CoreConcepts data-id="element-766" />
      <ProductAPIs data-id="element-767" />
      <IntegrationFlow data-id="element-768" />
      <SDKsTooling data-id="element-769" />
      <DeveloperSupport data-id="element-770" />
    </main>;
}